import { useState } from "react";
import {
  Box,
  Container,
  Divider,
  Paper,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { radius } from "../../../../theme";
import UploadB3 from "./uploadB3";
import Dropzone from "../../../util/ui/dropzone";
import { addDoc } from "firebase/firestore";
import { uploadBytes, ref, getStorage } from "firebase/storage";
import { forEach } from "lodash";
import moment from "moment";
import UploadDb from "../../../../db/uploadDb";
import felixAnalytics from "../../../../felixAnalytics";
import { SituacaoUpload } from "../../../../models/enum";
import Upload from "../../../../models/upload";
import { useUsuario } from "../../../../providers/usuarioProvider";
import UploadCorretora from "./uploadCorretora";

export default function UploadArquivos() {
  const [modo, setModo] = useState<"B3" | "Corretora">("B3");
  const { visualizado } = useUsuario();

  function onDropAccepted<T extends File>(files: T[]) {
    if (!!visualizado) {
      const uploadCollection = new UploadDb().collection({
        usuarioId: visualizado,
        uploadId: "",
      });
      forEach(files, (file) => {
        addDoc(
          uploadCollection,
          new Upload({
            id: "",
            nomeArquivoOriginal: file.name,
            situacao: SituacaoUpload.SALVO,
            dataUpload: moment(),
          })
        ).then((doc) => {
          return uploadBytes(
            ref(getStorage(), `/usuarios/${visualizado}/uploads/${doc.id}`),
            file,
            { customMetadata: { nome: file.name } }
          ).then(() =>
            felixAnalytics.track("nota_cadastrada", { tipo: "upload" })
          );
        });
      });
    }
  }

  return (
    <Paper variant="outlined" sx={{ borderRadius: `${radius.xl}px` }}>
      <Container maxWidth="lg" sx={{ py: 2 }}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <Typography
            variant="eyebrow"
            component="p"
            color="text.secondary"
            sx={{ pb: 1.5 }}
          >
            Importar arquivos
          </Typography>
          <ToggleButtonGroup
            color="primary"
            size="small"
            exclusive
            value={modo}
            onChange={(_e, value) => setModo(value)}
          >
            <ToggleButton value="B3" sx={{ minWidth: 100 }}>
              B3
            </ToggleButton>
            <ToggleButton value="Corretora" sx={{ minWidth: 100 }}>
              Corretora
            </ToggleButton>
          </ToggleButtonGroup>
          {modo === "B3" ? <UploadB3 /> : <UploadCorretora />}
          <Divider flexItem />
          <Box py={2} width="100%">
            <Dropzone onDropAccepted={onDropAccepted} />
          </Box>
        </Box>
      </Container>
    </Paper>
  );
}
